import * as React from 'react';
import { getFocusableChildren, bindKeypress } from '../../helpers/window-helpers';
import PromptModal from './prompt-modal';

export interface IModalProps {
    modalKey: string;
    title: string;
    message: string;
    cancelString?: string;
    confirmString?: string;
    confirmFunction?: any;
    cancelFunction?: any;
    closeFunction?: any;
    isError?: boolean;
    showModal?: boolean;
    modalClass?: string;
    priority?: number; // only use 1,2 or 3. 1 being highest
}

class Modal<T extends IModalProps> extends React.Component<T, { lastFocused: any }> {

    constructor(props) {
        super(props);
        this.state = { lastFocused: null };
        console.log("Pop-up shown (" + props.modalKey + ")");
    }

    componentDidMount() {
        this.setState({ lastFocused: document.activeElement });
        (document.activeElement as any).blur();
        var modal = document.getElementById('modal-container');
        if (modal != null && this.props.closeFunction != null) {
            let focusableElements = getFocusableChildren(modal);
            window.addEventListener('keydown', event => bindKeypress.bind(this)(event, focusableElements, this.props.closeFunction.bind(this)));
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', bindKeypress.bind(this));
        if (this.state.lastFocused !== null) {
            this.state.lastFocused.focus();
        }
    }

    render() {
        var modalClassName = 'modal-wrapper';

        if (this.props.modalClass) {
            modalClassName = this.props.modalClass + ' modal-wrapper';
        }

        if (this.props.priority) {
            modalClassName = modalClassName + " priority-" + this.props.priority;
        }

        return (
            <div tabIndex={-1} className={modalClassName} id="modal-wrapper" ref="modalWrapper" aria-live="polite">
                <div id="modal-overlay" className="modal-overlay" tabIndex={-1} onClick={this.props.cancelFunction ? () => { this.props.cancelFunction() } : null}></div>
                {this.renderModalContent()}
            </div>
        );
    }

    public renderModalContent() {
        return (
            <PromptModal {...this.props} />
        );
    }
}

export default Modal;